import { j as a } from "../jsx-runtime-DywqP_6a.js";
import * as e from "@radix-ui/react-dropdown-menu";
import { ChevronRightIcon as l, CheckIcon as c, DotIcon as m } from "lucide-react";
import * as r from "react";
import { c as d } from "../cn-dYga0KKN.js";
const M = e.Root, R = e.Trigger, I = e.Group, v = e.Portal, S = e.Sub, C = e.RadioGroup, p = r.forwardRef(({ className: t, inset: o, children: s, ...n }, i) => /* @__PURE__ */ a.jsxs(
  e.SubTrigger,
  {
    ref: i,
    className: d(
      "flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden focus:bg-accent data-[state=open]:bg-accent",
      o && "pl-8",
      t
    ),
    ...n,
    children: [
      s,
      /* @__PURE__ */ a.jsx(l, { className: "ml-auto h-4 w-4" })
    ]
  }
));
p.displayName = e.SubTrigger.displayName;
const u = r.forwardRef(({ className: t, ...o }, s) => /* @__PURE__ */ a.jsx(
  e.SubContent,
  {
    ref: s,
    className: d(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...o
  }
));
u.displayName = e.SubContent.displayName;
const f = r.forwardRef(({ className: t, sideOffset: o = 4, ...s }, n) => /* @__PURE__ */ a.jsx(e.Portal, { children: /* @__PURE__ */ a.jsx(
  e.Content,
  {
    ref: n,
    sideOffset: o,
    className: d(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...s
  }
) }));
f.displayName = e.Content.displayName;
const x = r.forwardRef(({ className: t, inset: o, ...s }, n) => /* @__PURE__ */ a.jsx(
  e.Item,
  {
    ref: n,
    className: d(
      "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      o && "pl-8",
      t
    ),
    ...s
  }
));
x.displayName = e.Item.displayName;
const b = r.forwardRef(({ className: t, children: o, checked: s, ...n }, i) => /* @__PURE__ */ a.jsxs(
  e.CheckboxItem,
  {
    ref: i,
    className: d(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: s,
    ...n,
    children: [
      /* @__PURE__ */ a.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ a.jsx(e.ItemIndicator, { children: /* @__PURE__ */ a.jsx(c, { className: "h-4 w-4" }) }) }),
      o
    ]
  }
));
b.displayName = e.CheckboxItem.displayName;
const w = r.forwardRef(({ className: t, children: o, ...s }, n) => /* @__PURE__ */ a.jsxs(
  e.RadioItem,
  {
    ref: n,
    className: d(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...s,
    children: [
      /* @__PURE__ */ a.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ a.jsx(e.ItemIndicator, { children: /* @__PURE__ */ a.jsx(m, { className: "h-4 w-4 fill-current" }) }) }),
      o
    ]
  }
));
w.displayName = e.RadioItem.displayName;
const h = r.forwardRef(({ className: t, inset: o, ...s }, n) => /* @__PURE__ */ a.jsx(
  e.Label,
  {
    ref: n,
    className: d(
      "px-2 py-1.5 text-sm font-semibold",
      o && "pl-8",
      t
    ),
    ...s
  }
));
h.displayName = e.Label.displayName;
const N = r.forwardRef(({ className: t, ...o }, s) => /* @__PURE__ */ a.jsx(
  e.Separator,
  {
    ref: s,
    className: d("-mx-1 my-1 h-px bg-muted", t),
    ...o
  }
));
N.displayName = e.Separator.displayName;
const g = ({
  className: t,
  ...o
}) => /* @__PURE__ */ a.jsx(
  "span",
  {
    className: d("ml-auto text-xs tracking-widest opacity-60", t),
    ...o
  }
);
g.displayName = "DropdownMenuShortcut";
export {
  M as DropdownMenu,
  b as DropdownMenuCheckboxItem,
  f as DropdownMenuContent,
  I as DropdownMenuGroup,
  x as DropdownMenuItem,
  h as DropdownMenuLabel,
  v as DropdownMenuPortal,
  C as DropdownMenuRadioGroup,
  w as DropdownMenuRadioItem,
  N as DropdownMenuSeparator,
  g as DropdownMenuShortcut,
  S as DropdownMenuSub,
  u as DropdownMenuSubContent,
  p as DropdownMenuSubTrigger,
  R as DropdownMenuTrigger
};
//# sourceMappingURL=DropdownMenu.js.map
